import axios from "axios";

import { IPostulateFormData } from "../shared/model/postulate-form-data";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  FETCH_POSTULATE_LIST: "postulate/FETCH_POSTULATE_LIST",
  RESET: "postulate/RESET",
};

const entities: IPostulateFormData = {};
const initialState = {
  loading: false,
  errorMessage: null,
  entities,
};

export type PostulateState = Readonly<typeof initialState>;

// RECUCER

export const postulateReducer = (
  state: PostulateState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_POSTULATE_LIST):
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_POSTULATE_LIST):
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.FETCH_POSTULATE_LIST):
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entities: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external/postulate/formdata";
export const getEntities = (id: string) => {
  return {
    type: ACTION_TYPES.FETCH_POSTULATE_LIST,
    payload: axios.get<IPostulateFormData>(`${apiUrl}/${id}`),
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
